module.exports = __webpack_public_path__ + "img/logo_caes_gatos.11e0eef2.jpg";